import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { ArrowLeft, MessageSquare, User2 } from "lucide-react";

export default function JobApplications() {
  const { id } = useParams();
  const [apps, setApps] = useState([]);
  const [job, setJob] = useState(null);

  useEffect(() => {
    api.get(`/jobs/${id}`).then((r) => setJob(r.data));
    api.get(`/applications/job/${id}`).then((r) => setApps(r.data));
  }, [id]);

  return (
    <div className="max-w-5xl mx-auto px-6 py-10" data-testid="job-applications-page">
      <Link to="/jobs/mine" className="inline-flex items-center text-sm text-slate-600 hover:text-slate-900 mb-4">
        <ArrowLeft className="w-4 h-4 mr-1" /> Retour
      </Link>
      <div className="mec-overline mb-2">Candidatures</div>
      <h1 className="font-display text-3xl font-bold text-slate-900 mb-6">{job?.title || "Offre"}</h1>

      <div className="space-y-3">
        {apps.length === 0 && <div className="mec-card p-12 text-center text-slate-500">Aucune candidature reçue.</div>}
        {apps.map((a) => (
          <div key={a.id} className="mec-card p-6">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex gap-3 flex-1 min-w-0">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold flex-shrink-0">
                  {a.candidate_name.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-slate-900">{a.candidate_name}</div>
                  <div className="text-xs text-slate-500 mb-2">
                    {new Date(a.created_at).toLocaleDateString("fr-FR")} • {a.candidate_profile?.headline || "Candidat"}
                  </div>
                  {(a.candidate_profile?.skills || []).length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {a.candidate_profile.skills.slice(0, 5).map((s, i) => (
                        <Badge key={i} variant="outline" className="text-[10px] border-slate-300">{s}</Badge>
                      ))}
                    </div>
                  )}
                  {a.cover_letter && (
                    <div className="text-sm text-slate-700 mt-2 p-3 bg-slate-50 rounded-md whitespace-pre-line border border-slate-200">
                      {a.cover_letter}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex gap-2">
                <Link to={`/candidates/${a.candidate_id}`}><Button size="sm" variant="outline" data-testid={`view-cand-${a.candidate_id}`}><User2 className="w-4 h-4 mr-1" /> Profil</Button></Link>
                <Link to={`/messages/${a.candidate_id}`}><Button size="sm" className="bg-[#004EEB] hover:bg-[#003BCC]"><MessageSquare className="w-4 h-4 mr-1" /> Contacter</Button></Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
